const Rocket = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id="paint0"
          x1="7.88332"
          y1="7.4291"
          x2="3.21642"
          y2="12.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#614EE5" />
          <stop offset="1" stopColor="#3A37CC" />
        </linearGradient>
        <linearGradient
          id="paint1"
          x1="16.5749"
          y1="16.1215"
          x2="11.908"
          y2="20.7884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#614EE5" />
          <stop offset="1" stopColor="#3A37CC" />
        </linearGradient>
        <linearGradient
          id="paint2"
          x1="21.2901"
          y1="2.70569"
          x2="7.24698"
          y2="16.7488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A67CFA" />
          <stop offset="1" stopColor="#614EE5" />
        </linearGradient>
        <linearGradient
          id="paint3"
          x1="2.74238"
          y1="17.8023"
          x2="6.20013"
          y2="21.2601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF696F" />
          <stop offset="1" stopColor="#FF2539" />
        </linearGradient>
      </defs>

      <path
        d="M5.20078 13L9.33078 8.86999L7.82078 7.35999C4.83078 7.98999 3.31078 9.17999 3.31078 9.17999C3.20078 9.24999 3.08078 9.32999 2.99078 9.42999C2.32078 10.1 2.32078 11.19 2.99078 11.86C3.04078 11.91 3.10078 11.96 3.16078 12C3.16078 12 3.22078 12.05 3.25078 12.07C4.14078 12.73 5.20078 12.98 5.20078 12.98V13Z"
        fill="url(#paint0)"
      />
      <path
        d="M11 18.8L15.13 14.67L16.64 16.18C16.01 19.17 14.82 20.69 14.82 20.69C14.75 20.81 14.67 20.92 14.57 21.01C13.9 21.68 12.81 21.68 12.14 21.01C12.09 20.96 12.04 20.9 12 20.84C12 20.84 11.96 20.78 11.93 20.75C11.27 19.86 11.02 18.8 11.02 18.8H11Z"
        fill="url(#paint1)"
      />
      <path
        d="M21.8308 3.76005C21.7708 3.37005 21.5908 3.00005 21.3008 2.71005C21.0108 2.42005 20.6308 2.24005 20.2508 2.18005C11.7008 0.640046 5.66084 10.03 5.66084 10.03V10.05C4.55084 11.83 5.16084 14.65 7.25084 16.74C9.34084 18.83 12.1708 19.44 13.9408 18.32H13.9608C13.9608 18.32 23.3608 12.29 21.8308 3.75005V3.76005Z"
        fill="url(#paint2)"
      />
      <path
        d="M18.7308 10.56C18.7308 10.56 18.7808 10.47 18.8008 10.42C18.8008 10.42 18.8108 10.39 18.8208 10.37C18.9308 10.14 19.0508 9.85997 19.1308 9.50997C19.3108 8.88997 19.4308 8.01997 19.2008 7.13997C19.1808 7.06997 19.1708 7.00997 19.1508 6.93997C19.1508 6.91997 19.1508 6.90997 19.1408 6.88997C19.0008 6.45997 18.7508 6.02997 18.3808 5.65997C18.3808 5.65997 18.3708 5.64997 18.3608 5.63997C18.3608 5.63997 18.3508 5.62997 18.3408 5.61997C17.9708 5.24997 17.5408 4.99997 17.1108 4.85997C17.1108 4.85997 17.0808 4.84997 17.0608 4.83997C16.9908 4.81997 16.9308 4.80997 16.8608 4.78997C15.9808 4.55997 15.1108 4.68997 14.4908 4.85997C14.1408 4.94997 13.8508 5.05997 13.6308 5.16997C13.6108 5.16997 13.5808 5.18997 13.5808 5.18997C13.5808 5.18997 13.4808 5.23997 13.4408 5.26997C13.1708 5.43997 12.6308 5.88997 12.6408 6.71997C12.7208 7.58997 13.3008 8.69997 14.2808 9.67997C14.2808 9.67997 14.2908 9.68997 14.3008 9.69997C14.3108 9.70997 14.3108 9.70997 14.3208 9.71997C15.3008 10.7 16.4208 11.28 17.2808 11.36C18.1108 11.37 18.5608 10.83 18.7308 10.56Z"
        fill="#D6C1FA"
      />
      <path
        d="M3.0105 17.57C3.0105 17.57 2.9505 17.65 2.9205 17.7C2.9205 17.7 2.9005 17.73 2.8905 17.74C2.7605 17.95 2.6105 18.2 2.4805 18.51C2.2205 19.06 1.9705 19.79 2.0005 20.48C2.0005 20.53 2.0005 20.59 2.0005 20.64C2.0005 20.65 2.0005 20.67 2.0005 20.68C2.0405 21.01 2.1705 21.32 2.4105 21.56C2.4105 21.56 2.4105 21.56 2.4205 21.57C2.4205 21.57 2.4205 21.57 2.4305 21.58C2.6705 21.82 2.9805 21.95 3.3105 21.99C3.3105 21.99 3.3405 21.99 3.3505 21.99C3.4005 21.99 3.4605 21.99 3.5105 21.99C4.2005 22.02 4.9305 21.77 5.4805 21.51C5.7805 21.38 6.0405 21.23 6.2505 21.1C6.2705 21.09 6.2905 21.07 6.2905 21.07C6.2905 21.07 6.3805 21.01 6.4205 20.98C6.6705 20.79 7.2005 20.33 7.3405 19.65C7.4305 18.95 7.1505 18.13 6.5105 17.5C6.5105 17.5 6.5105 17.5 6.5005 17.49C6.4905 17.48 6.5005 17.49 6.4905 17.48C5.8605 16.85 5.0405 16.56 4.3405 16.65C3.6605 16.79 3.1905 17.31 3.0105 17.57Z"
        fill="url(#paint3)"
      />
    </svg>
  );
};

export default Rocket;
